import React from 'react';
import Aux from '../hoc/Aux';
import TextDatenschutz from './Shared/TextDatenschutz';

const datenschutz = (props) => (
  <Aux>
    <div className="main-container">
       <div className="container">
          <div className="row justify-content-center">
             <div className="col-lg-11 col-xl-10">
              <TextDatenschutz />
             </div>
          </div>
       </div>
    </div>
  </Aux>
);

export default datenschutz;



// WEBPACK FOOTER //
// ./src/components/Datenschutz.js